import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { Remittance } from '../../../../models/remittance-model';
import { RemittanceService } from '../remittance.service';
import { isNilty } from '../../../../core/utils.service';
import { RemittanceFilters } from '../../../../models/filters/remittance-filters-model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-main-remittances-list',
  templateUrl: './main-remittances-list.component.html',
  styleUrls: ['./main-remittances-list.component.css'],
})
export class MainRemittancesListComponent implements OnInit {
  dataSource: MatTableDataSource<Remittance>;

  displayedColumns = [
    'paymentNumber',
    'vendor',
    'paymentTo',
    'amazonSupplierNumber',
    'supplierSiteName',
    'paymentDate',
    'paymentCurrency',
    'paymentAmount',
  ];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  resultsNumber: Observable<number>;

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private remittanceService: RemittanceService) {}

  ngOnInit() {
    this.resultsNumber = this.remittanceService.resultsNumber;

    if (isNilty(this.remittanceService.remittanceFilters)) {
      this.remittanceService.remittanceFilters = new RemittanceFilters();
    }
    this.remittanceService.remittanceFilters.pageNumber = 0;
    this.dataSource = new MatTableDataSource([]);
    this.loadRemittances(this.remittanceService.remittanceFilters);
  }

  loadRemittances(filters: RemittanceFilters) {
    this.remittanceService.getFilteredRemittances(filters).subscribe((r: Remittance[]) => {
      this.dataSource.data = r;
    });
  }

  loadPage() {
    this.remittanceService.remittanceFilters.pageNumber = this.paginator.pageIndex;
    this.remittanceService.remittanceFilters.pageSize = this.paginator.pageSize;
    this.loadRemittances(this.remittanceService.remittanceFilters);
  }

  onSort() {
    this.remittanceService.remittanceFilters.sortBy = this.sort.active;
    this.remittanceService.remittanceFilters.sortDirection = this.sort.direction;
    this.loadRemittances(this.remittanceService.remittanceFilters);
  }

  onFilter(filters: RemittanceFilters) {
    this.paginator.pageIndex = 0;
    this.loadRemittances(filters);
  }
}
